import React from 'react';
import PropTypes from 'prop-types';

import Paragraph from 'common/components/TouchpointEditor/components/TouchpointNodes/Paragraph';
import useDynamicTags from 'common/components/TouchpointEditor/hooks/useDynamicTags';

const TextParagraph = React.forwardRef((props, ref) => {
    const content = useDynamicTags(props.meta.content);

    return <Paragraph {...props} meta={{ ...props.meta, content }} ref={ref} />;
});

TextParagraph.propTypes = {
    meta: PropTypes.shape({
        content: PropTypes.string.isRequired,
    }).isRequired,
};

TextParagraph.splash = { ...Paragraph.splash };

export default TextParagraph;
